import Color from 'color';
import { MutableRefObject } from 'react';

export type TClassnames = string | Record<string, boolean>;

export type IReactRef =
  | ((instance: HTMLDivElement | null) => void)
  | MutableRefObject<HTMLDivElement | null>
  | null;

export enum SidebarStateEnum {
  EXPORT = 'export',
  ADJUST_PALETTE = 'adjustPalette',
  CLOSE = 'close',
}

export enum ExportEnum {
  COPY_LINK = 'Copy Link',
  PDF = 'Save as PDF',
  QR_CODE = 'Get the QR Code',
}

export type IPalettes = {
  color: Color;
  shadesIndex: number;
  isLocked: boolean;
  id: string;
  additionalInfo: AdditionalInfoEnum;
}[];

export type IPaletteSettings = {
  hue: number;
  saturation: number;
  brightness: number;
  temperature: number;
};

export enum SingleSettingsOptionsEnum {
  HEX = 'HEX',
  HSB = 'HSB',
  RGB = 'RGB',
  RYB = 'RYB',
}

export enum AdditionalInfoEnum {
  NAME = 'name',
  NONE = 'none',
  RGB = 'rgb',
  RYB = 'ryb',
}
